module.exports = __webpack_public_path__ + "img/charging.1d262164.png";